import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import { profiles as seedProfiles } from "../../../_helper/User/UserData/data";

// =============================================================================
// Chat store — BİRLEŞİK conversation modeli (WhatsApp/Telegram tarzı).
// Eski fragmente messagesStore (direct/group ayrı yollar + email-tarzı from/to/
// subject/body + directThreads + rail + launchIntent) YERİNE sıfırdan yazıldı.
//
// Model:
//   me                : geçerli kullanıcı (Zehra Ecer)
//   contacts[]        : { id, name, avatar, title, kind: 'user'|'client'|'lead', company }
//   conversations[]   : { id, type:'dm'|'group', contactId?, participantIds?, name,
//                         avatar?, color?, messages[], pinned, lastReadAt }
//   message           : { id, authorId, text, attachments[], createdAt }
//
// Tek conversation listesi; DM ve grup aynı kabukta akar. "me" gönderdiyse
// authorId==='me' → balon sağda.
// =============================================================================

const PIN_KEY = "pms-chat-pins-v1";
const READ_KEY = "pms-chat-read-v1";

const ME = {
  id: "me",
  name: "Zehra Ecer",
  avatar: "https://i.pravatar.cc/160?img=30",
};

// Servis/sistem hesapları (profillerde olmayan ama yazışılan taraflar).
const serviceContacts = [
  { id: "svc-support", name: "Support", title: "Support team", kind: "user", avatar: "https://i.pravatar.cc/160?img=24" },
  { id: "svc-hrbot", name: "HR Bot", title: "Automation", kind: "user", avatar: "https://i.pravatar.cc/160?img=15" },
  { id: "svc-admin", name: "System Admin", title: "Admin", kind: "user", avatar: "https://i.pravatar.cc/160?img=13" },
];

// profiles → contacts (id "1" = Zehra Ecer = me → hariç).
const profileContacts = (seedProfiles || [])
  .filter((p) => p?.overview?.name && p.id !== "1")
  .map((p) => ({
    id: `p-${p.id}`,
    name: p.overview.name,
    avatar: p.overview.avatar || null,
    title:
      p.overview.title ||
      p.overview.role ||
      p.jobInfo?.title ||
      (p.type === "client" ? "Client" : p.type === "leads" ? "Lead" : ""),
    kind: p.type === "leads" ? "lead" : p.type === "client" ? "client" : "user",
    company: p.companyName || null,
  }));

const CONTACTS = [...serviceContacts, ...profileContacts];
const contactById = (id) => CONTACTS.find((c) => c.id === id) || null;

const at = (s) => new Date(s).getTime();
let _mid = 0;
const m = (authorId, text, createdAt, attachments = []) => ({
  id: `m${++_mid}`,
  authorId,
  text,
  attachments,
  createdAt,
});

// AI asistan otomatik yanıtları (demo — gerçek backend gelince LLM çağrısı).
const AI_REPLIES = [
  "Bunu birlikte çözebiliriz — biraz daha detay paylaşır mısın?",
  "Tabii! İşte önerebileceğim birkaç adım var. Hangisinden başlamak istersin?",
  "Anladım. Kısaca özetlersem: bu konuda en hızlı yol şu olabilir.",
  "Harika bir soru. İstersen bunu adım adım açıklayayım.",
  "Not aldım. Sana bir taslak hazırlayabilirim, ister misin?",
  "Bununla ilgili birkaç iyi pratik paylaşayım.",
];
const aiReply = (text) => AI_REPLIES[(String(text).length || 0) % AI_REPLIES.length];

// Seed conversations (gerçekçi içerik — ekrandaki kişilerle örtüşür).
const seedConversations = () => [
  {
    id: "c-ai",
    type: "ai",
    pinned: true,
    messages: [
      m("ai", "Merhaba 👋 Ben senin AI asistanın. Görev özetleme, taslak yazma, fikir üretme — ne istersen yardımcı olurum.", at("2026-02-09T08:00:00")),
    ],
  },
  {
    id: "c-support",
    type: "dm",
    contactId: "svc-support",
    pinned: false,
    messages: [
      m("svc-support", "Logları inceledik, hata düzeltmesi yayına alındı.", at("2026-02-07T11:05:00")),
      m("me", "Süper, teşekkürler. Tekrar test ediyorum.", at("2026-02-07T11:12:00")),
      m("svc-support", "Talebiniz kapatılmıştır. Sorun devam ederse yanıtlayın.", at("2026-02-09T23:41:00")),
    ],
  },
  {
    id: "c-sefa",
    type: "dm",
    contactId: "p-2",
    pinned: true,
    messages: [
      m("p-2", "Bugünkü toplantının özetini aşağıya bıraktım…", at("2026-02-05T09:00:00")),
      m("me", "Eline sağlık, inceliyorum.", at("2026-02-05T09:14:00")),
      m("p-2", "Gece gelen 500'leri Grafana'da işaretledim.", at("2026-02-07T12:20:00")),
      m("p-2", "Merhaba, bu bir test iletisidir.", at("2026-02-09T23:41:00")),
    ],
  },
  {
    id: "c-admin",
    type: "dm",
    contactId: "svc-admin",
    pinned: false,
    messages: [
      m("svc-admin", "Hesabınızda olağan dışı bir oturum açma tespit edildi.", at("2025-07-30T14:45:00")),
      m("me", "Bendim, endişe yok.", at("2025-07-30T14:50:00")),
      m("svc-admin", "Hey, I received your note. Will check and get back.", at("2026-02-07T09:10:00")),
      m("me", "Thanks! Waiting for your update.", at("2026-02-07T09:13:00")),
      m("svc-admin", "Yarın sabah 09:00'da kısa bir bakım var, haberin olsun.", at("2026-02-07T09:15:00")),
    ],
  },
  {
    id: "c-elif",
    type: "dm",
    contactId: "p-3",
    pinned: false,
    messages: [
      m("p-3", "Yeni dashboard tasarımını Figma'ya yükledim, bakar mısın?", at("2026-02-08T15:30:00")),
      m("me", "Harika görünüyor 👌 birkaç not düştüm.", at("2026-02-08T16:02:00")),
    ],
  },
  {
    id: "c-banu",
    type: "dm",
    contactId: "p-9",
    pinned: false,
    messages: [
      m("p-9", "Yarın kısa bir demo yapabilir miyiz?", at("2026-02-06T17:30:00")),
    ],
  },
  {
    id: "c-acme",
    type: "dm",
    contactId: "p-4",
    pinned: false,
    messages: [
      m("p-4", "Sözleşme taslağını gönderdik, dönüş bekliyoruz.", at("2026-02-04T13:20:00")),
      m("me", "Bugün içinde geri döneriz.", at("2026-02-04T14:05:00")),
    ],
  },
  {
    id: "g-design",
    type: "group",
    name: "Design Guild",
    color: "#6366f1",
    participantIds: ["p-2", "p-3", "svc-admin"],
    pinned: false,
    messages: [
      m("p-3", "Komponent kütüphanesini v2'ye taşıyalım mı?", at("2026-02-08T10:10:00")),
      m("p-2", "+1, token'lar hazır.", at("2026-02-08T10:14:00")),
      m("me", "Bu sprint planına alalım.", at("2026-02-08T10:20:00")),
    ],
  },
  {
    id: "g-release",
    type: "group",
    name: "Release 4.2",
    color: "#0ea5e9",
    participantIds: ["svc-support", "svc-admin", "p-2"],
    pinned: false,
    messages: [
      m("svc-admin", "Staging'e deploy tamam, smoke test bekliyoruz.", at("2026-02-09T18:40:00")),
    ],
  },
];

const lastMsg = (c) => c.messages[c.messages.length - 1] || null;
const lastActivity = (c) => (lastMsg(c)?.createdAt ?? 0);

const initialsOf = (name = "?") =>
  String(name || "?")
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

// Conversation görünüm meta'sı (name/avatar/initials/color) — DM contact'tan,
// grup explicit alandan.
const decorate = (c) => {
  if (c.type === "ai") {
    return { ...c, displayName: "AI Asistan", avatar: null, initials: "AI", color: "#6d28d9", isAI: true };
  }
  if (c.type === "group") {
    return { ...c, displayName: c.name, avatar: null, initials: initialsOf(c.name), color: c.color || "#64748b" };
  }
  const contact = contactById(c.contactId);
  return {
    ...c,
    displayName: contact?.name || "Bilinmeyen",
    avatar: contact?.avatar || null,
    initials: initialsOf(contact?.name),
    contact,
    color: "#0ea5e9",
  };
};

const readPersist = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "null");
  } catch {
    return null;
  }
};

const ChatContext = createContext(null);

export const ChatProvider = ({ children }) => {
  const [conversations, setConversations] = useState(seedConversations);
  const [open, setOpen] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [query, setQuery] = useState("");
  const [view, setView] = useState("list"); // mobil: 'list' | 'chat' | 'new'
  const [expanded, setExpanded] = useState(false); // desktop: tam-ekran kapla

  // Pin + okundu durumunu localStorage'dan hidrate et.
  useEffect(() => {
    const pins = readPersist(PIN_KEY);
    const reads = readPersist(READ_KEY);
    if (pins || reads) {
      setConversations((prev) =>
        prev.map((c) => ({
          ...c,
          pinned: pins?.[c.id] ?? c.pinned,
          lastReadAt: reads?.[c.id] ?? c.lastReadAt ?? 0,
        }))
      );
    }
  }, []);

  const persistPins = useCallback((list) => {
    const map = {};
    list.forEach((c) => (map[c.id] = !!c.pinned));
    try {
      localStorage.setItem(PIN_KEY, JSON.stringify(map));
    } catch {
      /* yoksay */
    }
  }, []);

  const persistReads = useCallback((list) => {
    const map = {};
    list.forEach((c) => (map[c.id] = c.lastReadAt || 0));
    try {
      localStorage.setItem(READ_KEY, JSON.stringify(map));
    } catch {
      /* yoksay */
    }
  }, []);

  const decorated = useMemo(() => conversations.map(decorate), [conversations]);

  const unreadOf = useCallback((c) => {
    const lastRead = c.lastReadAt || 0;
    return c.messages.filter((msg) => msg.authorId !== "me" && msg.createdAt > lastRead).length;
  }, []);

  // Sıralı (pinned önce, sonra son aktiviteye göre) + arama filtreli.
  const sorted = useMemo(() => {
    const list = [...decorated].sort((a, b) => {
      if (!!b.pinned !== !!a.pinned) return b.pinned ? 1 : -1;
      return lastActivity(b) - lastActivity(a);
    });
    const q = query.trim().toLowerCase();
    if (!q) return list;
    return list.filter((c) => {
      const hay = [c.displayName, lastMsg(c)?.text, c.contact?.title, c.contact?.company]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return hay.includes(q);
    });
  }, [decorated, query]);

  const unreadCount = useMemo(
    () => decorated.reduce((n, c) => n + (unreadOf(c) > 0 ? 1 : 0), 0),
    [decorated, unreadOf]
  );

  const activeConversation = useMemo(
    () => decorated.find((c) => c.id === activeId) || null,
    [decorated, activeId]
  );

  const markRead = useCallback(
    (id) => {
      setConversations((prev) => {
        const next = prev.map((c) =>
          c.id === id ? { ...c, lastReadAt: Date.now() } : c
        );
        persistReads(next);
        return next;
      });
    },
    [persistReads]
  );

  const setActive = useCallback(
    (id) => {
      setActiveId(id);
      setView("chat");
      if (id) markRead(id);
    },
    [markRead]
  );

  const openPanel = useCallback(() => setOpen(true), []);
  const closePanel = useCallback(() => {
    setOpen(false);
    setExpanded(false);
  }, []);
  const togglePanel = useCallback(() => setOpen((o) => !o), []);
  const toggleExpand = useCallback(() => setExpanded((e) => !e), []);
  const backToList = useCallback(() => setView("list"), []);
  const openNewChat = useCallback(() => setView("new"), []);

  // contactId ile DM bul/oluştur ve aç.
  const startWith = useCallback(
    (contactId) => {
      let target = null;
      setConversations((prev) => {
        const existing = prev.find((c) => c.type === "dm" && c.contactId === contactId);
        if (existing) {
          target = existing.id;
          return prev;
        }
        const id = `c-${contactId}-${Date.now()}`;
        target = id;
        return [
          { id, type: "dm", contactId, pinned: false, messages: [], lastReadAt: Date.now() },
          ...prev,
        ];
      });
      // setConversations async; activeId'i contactId'den deterministik bul.
      setTimeout(() => {
        setConversations((prev) => {
          const found = prev.find((c) => c.type === "dm" && c.contactId === contactId);
          if (found) {
            setActiveId(found.id);
            setView("chat");
          }
          return prev;
        });
      }, 0);
      return target;
    },
    []
  );

  const send = useCallback((id, { text = "", attachments = [] } = {}) => {
    const clean = String(text || "").trim();
    if (!clean && attachments.length === 0) return;
    setConversations((prev) =>
      prev.map((c) =>
        c.id === id
          ? {
              ...c,
              messages: [
                ...c.messages,
                {
                  id: `m${++_mid}`,
                  authorId: "me",
                  text: clean,
                  attachments,
                  createdAt: Date.now(),
                },
              ],
              lastReadAt: Date.now(),
            }
          : c
      )
    );
    // AI sohbetinde otomatik yanıt (demo).
    if (id === "c-ai" && clean) {
      const reply = aiReply(clean);
      setTimeout(() => {
        setConversations((prev) =>
          prev.map((c) =>
            c.id === "c-ai"
              ? {
                  ...c,
                  messages: [
                    ...c.messages,
                    { id: `m${++_mid}`, authorId: "ai", text: reply, attachments: [], createdAt: Date.now() },
                  ],
                }
              : c
          )
        );
      }, 800);
    }
  }, []);

  // AI sohbetini aç (AI butonu → doğrudan AI ile yazışma).
  const openAI = useCallback(() => {
    setOpen(true);
    setActiveId("c-ai");
    setView("chat");
    markRead("c-ai");
  }, [markRead]);

  // Yeni grup oluştur (isim + üyeler) ve aç.
  const createGroup = useCallback(({ name, memberIds = [], color = "#6366f1" } = {}) => {
    const clean = String(name || "").trim() || "Yeni grup";
    const id = `g-${Date.now()}`;
    setConversations((prev) => [
      { id, type: "group", name: clean, color, participantIds: memberIds, pinned: false, messages: [], lastReadAt: Date.now() },
      ...prev,
    ]);
    setTimeout(() => {
      setActiveId(id);
      setView("chat");
    }, 0);
    return id;
  }, []);

  const togglePin = useCallback(
    (id) => {
      setConversations((prev) => {
        const next = prev.map((c) => (c.id === id ? { ...c, pinned: !c.pinned } : c));
        persistPins(next);
        return next;
      });
    },
    [persistPins]
  );

  // ---- Geri-uyumlu köprü (notification entegrasyonu eski API'yi çağırıyor) ----
  const openFloating = useCallback(() => setOpen(true), []);
  const openConversation = useCallback(
    (arg) => {
      setOpen(true);
      const id = typeof arg === "string" ? arg : arg?.id;
      if (id) {
        setConversations((prev) => {
          const found =
            prev.find((c) => c.id === id) ||
            prev.find((c) => c.type === "dm" && c.contactId === id);
          if (found) {
            setActiveId(found.id);
            setView("chat");
          }
          return prev;
        });
      }
    },
    []
  );

  const authorMeta = useCallback((authorId) => {
    if (authorId === "me") return ME;
    if (authorId === "ai") return { id: "ai", name: "AI Asistan", avatar: null };
    return contactById(authorId) || { id: authorId, name: "Bilinmeyen", avatar: null };
  }, []);

  const value = {
    me: ME,
    contacts: CONTACTS,
    conversations: sorted,
    allConversations: decorated,
    activeConversation,
    activeId,
    open,
    view,
    expanded,
    toggleExpand,
    query,
    setQuery,
    unreadCount,
    unreadOf,
    lastMsg,
    authorMeta,
    // actions
    openPanel,
    closePanel,
    togglePanel,
    setActive,
    backToList,
    openNewChat,
    startWith,
    send,
    togglePin,
    markRead,
    openAI,
    createGroup,
    // backward-compat (notification)
    openFloating,
    openConversation,
  };

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

export const useChat = () => {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error("useChat must be used inside ChatProvider");
  return ctx;
};

export default ChatContext;
